module.exports = __webpack_public_path__ + "03efccff0607b6a44a35347aa897ca10.jpg";